import type { ChatError } from '../models';

export function isRetryableError(error: ChatError): boolean {
  return error.statusCode === 503 || error.statusCode === 0;
}
